import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutConfigService, CheckoutStepService } from '@spartacus/checkout/base/components';
import { RoutingConfigService } from '@spartacus/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomCheckoutB2bGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.checkoutStepService.steps$.pipe(
      map(() => {
        if (route.url.length == 1 && route.url[0].path === 'checkout') {
          this.checkoutStepService.goToStepWithIndex(0);
        }
        return true;
      })
    );
  }

  private readonly firstStep$ = this.checkoutStepService.steps$.pipe(
    map((steps) => {
      return this.router.parseUrl(this.routingConfigService.getRouteConfig(steps[0].routeName)?.paths?.[0] as string);
    })
  );

  constructor(
    protected router: Router,
    protected routingConfigService: RoutingConfigService,
    protected checkoutConfigService: CheckoutConfigService,
    protected activeCartFacade: ActiveCartFacade,
    protected checkoutStepService: CheckoutStepService
  ) {}
}
